/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.TEXT_AREA = (function () {

    return function () {
        this.resourceKey = 'Survey.Sidebar.OpenEnded';
        this.jsonType = 'TEXT_AREA';

        Greenmile.Survey.Sidebar.Generic.apply(this, arguments);

        this.getPreviewContent = function (question) {
            var textInput      = document.createElement('textarea'),
                inputContainer = document.createElement('div');
            textInput.value = question && question.defaultAnswer ? question.defaultAnswer : '';

            inputContainer.id = question.id;
            inputContainer.appendChild(textInput);

            return inputContainer;

        };
    };

}());
